import api from './interceptor'
import * as config from './../config/config'

export async function get_ListeRegion() {
  try {
    const response = await api.get(config.REACT_APP_ENDPOINT_LIST_REGION);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export async function updateRegion(data) {
  try {
    const response = await api.put(config.REACT_APP_ENDPOINT_UPDATE_REGION + '/' + data['id'], {
      "nom": data['nom']
    })
    return response.data
  } catch (error) {
    throw (error)
  }
}

export async function createRegion(data) {
  try {
    const response = await api.post(config.REACT_APP_ENDPOINT_CREATE_REGION, {
      "id" : data['id'],
      "nom" : data['nom']
    })
    return response.data
  } catch (error) {
    throw (error)
  }
}

export async function deleteRegion(data) {
  try{
    const response = await api.delete(config.REACT_APP_ENDPOINT_DELETE_REGION + '/' + data['id'])
    return response.data
  } catch (error) {
    throw (error)
  }
}

export async function carburantConfig() {
  try{
    const response = await api.get(config.REACT_APP_ENDPOINT_CARBURANT_CONFIG)
    return response.data
  } catch (error) {
    throw (error)
  }
}